import { useUser } from "../../../fetch/fetch.user.ts";
import { EMPTY_USER_PROFILE } from "../../../const/typeDefault/User.ts";

const UserTitle = ({ userId }: { userId: string }) => {
  const { user, isError, isLoading } = useUser(userId, EMPTY_USER_PROFILE);
  if (isLoading) {
    return "Loading";
  }
  if (isError) {
    return isError.message;
  }
  return user.username;
};
export default UserTitle;
